<template>
  <div id="com-destination" v-show="show">
    <div class="container-fluid">
      <div class="row com-destination-top">
        <div class="alert alert-info alert-info_zgb" role="alert" style="height:60px;">
          <!--<el-row>
                    <el-col :span="12">
                        <div class="sub-title">输入后匹配输入建议</div>
                        <el-autocomplete class="inline-input"
                                         v-model="state2"
                                         :fetch-suggestions="querySearch"
                                         placeholder="请输入关键字"
                                         :trigger-on-focus="false"
                                         @select="handleSelect"></el-autocomplete>
                    </el-col>
          </el-row>-->
          <el-row>
            <el-col :xs="6">
              <i
                class="el-icon-arrow-left"
                style="font-size:32px;color:#fff;position:relative;line-height:60px;left:-20px;"
                v-on:click="hideEvent"
              ></i>
            </el-col>
            <!--<el-col :xs="8">-->
            <div class="input-group">
              <input
                type="text"
                id="com-destination-search"
                class="form-control"
                placeholder="点击选择城市"
                v-bind:value="searchName"
                v-on:input="chagneSearchName($event)"
              >
              <!-- <el-input placeholder="请输入内容" ></el-input> -->
            </div>
            <!--</el-col>-->
          </el-row>

          <!--<span class="text-center fengkuai">{{title}}</span>-->
        </div>
      </div>
      <!--<div class="row">
            <p>&nbsp;</p>
            <p>
                <span class="kuai_left" id="com-destination-history">定位/历史</span>
            </p>
            <ul>
                <li class="li_hotcity">
                    <a href="javascript:;">上海</a>
                </li>
                <li class="li_hotcity">
                    <a href="javascript:;">广州</a>
                </li>
            </ul>
      </div>-->
      <!-- <div class="row row_hot clearfix" id="com-destination-hot">
            <p class="float">
                <span class="kuai_left">热门城市</span>
            </p>
            <ul>
                <li class="li_hotcity">
                    <a href="javascript:;" v-on:click="selectEvent(type == 2 || type == 3 ? { 'CN': 'Beijing Capital International Airport', 'NAME': '北京首都', 'CODE': 'PEK' } : { 'CN': 'BJI', 'NAME': '北京', 'CODE': 'BJP' })">北京</a>
                </li>
                <li class="li_hotcity">
                    <a href="javascript:;" v-on:click="selectEvent(type == 2 || type == 3 ? { 'CN': 'Shanghai Hongqiao International Airport', 'NAME': '上海虹桥', 'CODE': 'SHA' } : { 'CN': 'SHA', 'NAME': '上海', 'CODE': 'SHH' })">上海</a>
                </li>
                <li class="li_hotcity">
                    <a href="javascript:;" v-on:click="selectEvent(type == 2 || type == 3 ? { 'CN': 'GuangZhou', 'NAME': '广州白云', 'CODE': 'CAN' } : { 'CN': 'GZH', 'NAME': '广州', 'CODE': 'GZQ' })">广州</a>
                </li>
            </ul>
            <ul>
                <li class="li_hotcity">
                    <a href="javascript:;" v-on:click="selectEvent(type == 2 || type == 3 ? { 'CN': 'WuHan', 'NAME': '武汉天河', 'CODE': 'WUH' } : { 'CN': 'WHA', 'NAME': '武汉', 'CODE': 'WHN' })">武汉</a>
                </li>
                <li class="li_hotcity">
                    <a href="javascript:;" v-on:click="selectEvent(type == 2 || type == 3 ? { 'CN': 'NanJing', 'NAME': '南京禄口', 'CODE': 'NKG' } : { 'CN': 'NJI', 'NAME': '南京', 'CODE': 'NJH' })">南京</a>
                </li>
                <li class="li_hotcity">
                    <a href="javascript:;" v-on:click="selectEvent(type == 2 || type == 3 ? { 'CN': 'ShenZhen', 'NAME': '深圳宝安', 'CODE': 'SZX' } : { 'CN': 'SZH', 'NAME': '深圳', 'CODE': 'SZQ' })">深圳</a>
                </li>
            </ul>
      </div>-->
      <div class="row row_bgcolor">
        <template v-for="item in group">
          <div v-bind:id="'com-destination-' + item.letter">
            <p class="p_style">
              <span class="letter">{{item.letter.toUpperCase()}}</span>
            </p>
            <ul>
              <li class="li_letter" v-for="subitem in item.items" v-on:click="selectEvent(subitem)">
                <a href="javascript:;">{{subitem.name}}</a>
              </li>
            </ul>
          </div>
        </template>
      </div>
      <div class="div_right">
        <ul>
          <!--<li class="li_style"><a href="javascript:;" v-on:click="hideEvent">返回</a></li>-->
          <!--<li class="li_style"><a href="#com-destination-history">历史</a></li>-->
          <li class="li_style">
            <a href="#com-destination-hot">热门</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-a">A</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-b">B</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-c">C</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-d">D</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-e">E</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-f">F</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-g">G</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-h">H</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-i">I</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-j">J</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-k">K</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-l">L</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-m">M</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-n">N</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-o">O</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-p">P</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-q">Q</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-r">R</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-s">S</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-t">T</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-w">W</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-x">X</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-y">Y</a>
          </li>
          <li class="li_style">
            <a href="#com-destination-z">Z</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="am-dropdown" id="com-destination-dropdown" v-show="dropdownCities.length > 0">
      <ul class="am-dropdown-content">
        <!-- <bs-list> -->
        <li v-for="item in dropdownCities" v-on:click="selectEvent(item)">
          <a>{{item.name}}</a>
        </li>
        <!-- </bs-list> -->
      </ul>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { queryModule } from "../../actions/portal/protal";
require("../../styles/travel/destination.scss");
export default {
  props: [
    "code",
    "title",
    "type",
    "days",
    "show",
    "destinationCallBack", 
    "showCallBack"
  ], // destinationCallBack回调方法
  data() {
    return {
      // airports: airportJson,
      stations: [],
      searchName: "",
      ak:"9862E14DE5d6373de36cd8e91503044b"
    };
  },
  components: {
    BsList: "../../components/bs-list.vue"
  },
  mounted: function() {
    //var self = this;
    //$.getJSON("/src/Scripts/AirportJson.js", function (result) {
    //    self.airports = result;
    //});
    //$.getJSON("/src/Scripts/StationJson.js", function (result) {
    //    self.stations = result;
    //});
    //setTimeout(function () {
    //    $("#com-destination-search").focus();
    //}, 1000);
    let $this = this;
    queryModule().then(res => {
      $this.stations = res.data;
    });
  },
  computed: {
    // 按字母分组的站
    stationGroup: function() {
      var self = this;
      var group = _.groupBy(self.stations, function(item) {
        return item.jianPin[0].toLowerCase();
      });
      var result = _.map(group, function(item, index) {
        return {
          letter: index,
          items: item
        };
      });
      return result;
    },
    // 按字母分组的站
    airportGroup: function() {
      var self = this;
      var group = _.groupBy(self.airports, function(item) {
        return item.jianPin[0].toLowerCase();
      });
      var result = _.map(group, function(item, index) {
        console.log("airport", index);
        return {
          letter: index,
          items: item
        };
      });
      return result;
    },
    group: function() {
      // if (this.type=="1") {
      //     return this.airportGroup;
      // } else {
      return this.stationGroup;
      // }
    },
    // 输入字符，得到数组
    dropdownCities: function() {
      var self = this;
      if (self.searchName.length > 0) {
        // if (this.type=="1") {
        var cities = _.filter(self.stations, function(item) {
          return (
            _.includes(item.name, self.searchName) ||
            _.startsWith(
              item.pinYin.toLowerCase(),
              self.searchName.toLowerCase()
            ) ||
            _.startsWith(
              item.jianPin.toLowerCase(),
              self.searchName.toLowerCase()
            )
          );
        });

        return cities;
        // }
        //      else {
        // var cities = _.filter(self.stations, function (item) {
        //     return _.includes(item.NAME, self.searchName)
        //         || _.startsWith(item.CN.toLowerCase(), self.searchName.toLowerCase())
        //         || _.startsWith(item.PINYIN.toLowerCase(), self.searchName.toLowerCase())
        //         || _.startsWith(item.PY.toLowerCase(), self.searchName.toLowerCase())
        //         ;
        // });

        // return cities
        //     }
      } else {
        return [];
      }
    }
  },
  methods: {
    selectEvent: function(item) {
      this.searchName = "";
      if (this.destinationCallBack) {
        if (this.type !== 1) {
          item.code = this.code;
        } else {
          item.code = this.id;
        }
        this.destinationCallBack(item,this.days);
      }
    },
    hideEvent: function() {
      this.searchName = "";
      if (this.showCallBack) {
        this.showCallBack();
      }
    },
    // 修改搜索
    chagneSearchName: function($event) {
      this.searchName = $event.target.value;
    },
    // 点击外部
    clickWrap: function() {
      this.searchName = "";
    },
    // 根据城市名称，从数集中得到对应的站点
    getCityModel: function(city) {
      var self = this;
      var cityModel = _.find(self.stations, function(item) {
        return _.includes(item.name, city) || _.includes(city, item.name);
      });

      return cityModel || {};
    },
    // 根据城市名称，从数集中得到对应的飞机场
    getAirModel: function(city) {
      var self = this;
      var cityModel = _.find(self.airports, function(item) {
        return (
          (item.CITY.length > 0 &&
            (_.includes(item.CITY, city) || _.includes(city, item.CITY))) ||
          _.includes(item.name, city) ||
          _.includes(city, item.name)
        );
      });

      return cityModel || {};
    }
    //querySearch(queryString, cb) {
    //    var self = this;
    //    var airports = self.airports;
    //    var results = queryString ? restaurants.filter(this.createFilter(queryString)) : self.airports;
    //    // 调用 callback 返回建议列表的数据
    //    cb(results);
    //},
    //createFilter(queryString) {
    //    return (airports) => {
    //        return (airports.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //    };
    //},
    //handleSelect(item) {
    //    console.log(item);
    //}
  }
};
</script>
